// Import the main FirebaseService
// This file is just a re-export for backward compatibility
import firebaseService from '../services/FirebaseService';
export { DEMO_MODE } from '../services/FirebaseService';
export default firebaseService; 